import type { SVGProps } from "react";

export function IconEarth(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="16" cy="16" r="14" fill="#56A4F1" />
      <mask
        id="mask0_2665_14062"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="30"
        height="30"
      >
        <circle
          cx="16"
          cy="16"
          r="14"
          fill="#D9D9D9"
          stroke="black"
          strokeWidth="1.5"
        />
      </mask>
      <g mask="url(#mask0_2665_14062)">
        <path d="M20.5 24L24 17L22 13H14V19H17.5V24H20.5Z" fill="white" />
        <path
          d="M15 7.5V10H23.5L27 16.5L33.5 10L26.5 -1.5L17.5 7.5H15Z"
          fill="white"
        />
        <path d="M7 22H-5V33H7H10.5V25.5L7 22Z" fill="white" />
        <rect x="-5" y="3" width="12" height="11" fill="white" />
        <circle cx="16" cy="16" r="14" stroke="black" strokeWidth="1.5" />
      </g>
    </svg>
  );
}
